import { initializeFullStory } from "./main-helper";
import { setAppDynamics } from "./app-dynamics";

initializeFullStory();
setAppDynamics();

import("./bootstrap");
